import { useChatStore } from '../stores/chatStore'
import { deleteChatOnServer } from '../services/api'

export default function Sidebar() {
  const chats = useChatStore((s) => s.chats)
  const currentChatId = useChatStore((s) => s.currentChatId)
  const sidebarOpen = useChatStore((s) => s.sidebarOpen)
  const createChat = useChatStore((s) => s.createChat)
  const selectChat = useChatStore((s) => s.selectChat)
  const deleteChat = useChatStore((s) => s.deleteChat)
  const setSidebarOpen = useChatStore((s) => s.setSidebarOpen)
  const setShowImageGen = useChatStore((s) => s.setShowImageGen)

  return (
    <>
      {sidebarOpen && <div className="fixed inset-0 bg-black/50 z-20 lg:hidden" onClick={() => setSidebarOpen(false)} />}
      <aside className={`${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0 fixed lg:relative z-30 w-[260px] h-full bg-gray-900 border-r border-gray-800 flex flex-col transition-transform duration-200`}>
        <div className="p-4 flex items-center justify-between border-b border-gray-800/50">
          <h1 className="font-semibold text-sm text-white">The Italian Job</h1>
          <button onClick={() => setShowImageGen(true)} className="p-1.5 rounded-lg hover:bg-gray-800 text-gray-400 hover:text-white text-xs" title="Image Gen">🎨</button>
        </div>
        <div className="p-2">
          <button onClick={createChat} className="w-full flex items-center gap-2 px-3 py-2.5 rounded-lg border border-gray-700 hover:bg-gray-800 text-gray-300 text-sm transition-colors">
            + New Chat
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-2 pb-2">
          {chats.length === 0 && <p className="text-gray-600 text-xs text-center mt-4">No chats yet</p>}
          {chats.map((chat) => (
            <div key={chat.id} onClick={() => selectChat(chat.id)}
              className={`group flex items-center gap-2 px-3 py-2 rounded-lg cursor-pointer text-sm transition-colors mb-0.5 ${chat.id === currentChatId ? 'bg-gray-800 text-white' : 'text-gray-400 hover:bg-gray-850 hover:text-white'}`}>
              <span className="truncate flex-1">{chat.title || 'New Chat'}</span>
              <button onClick={(e) => { e.stopPropagation(); deleteChat(chat.id); deleteChatOnServer(chat.id) }}
                className="opacity-0 group-hover:opacity-100 text-gray-500 hover:text-red-400 p-0.5">×</button>
            </div>
          ))}
        </div>
        <div className="p-3 border-t border-gray-800/50 text-[11px] text-gray-600">
          OpenRouter · Hermes 4 70B
        </div>
      </aside>
    </>
  )
}
